'use strict';

var $ = window.jQuery;

var waitingClass = 'isWaiting';
var waitClass = 'wait';
var focusClass = 'isFocus';
var hoverClass = 'isHover';
var formButtons = 'input[type=submit], input[type=button], button';
var filledClass = 'isFilled';

var isAJAXSetup = false;
var $body = $(document.body);
var _forms = null;


/**
 * Use:
 * var Forms = require('./lib/Forms.js');
 * Forms.init();
 * 
 * You can then use the public methods to do a few things. For example use Forms.getForms() to get a reference to call forms.
 */
var Forms = {};
 
/**
 * Get forms
 */
Forms.getForms = function() {
	if (_forms === null) {
		_forms = $('form');
	}
	return _forms;
}

/**
 * Reset cached form references.
 * @private
 */
function resetForms() {
	_forms = null;
}


/**
 * Pause forms from submitting
 */
Forms.pauseForms = function() {
	var forms = Forms.getForms();
	forms.addClass(waitingClass);
	forms.find(formButtons)
		.css({'visibility': 'hidden'})
		.after('<span class="' + waitClass + '"><i></i></span>')
		.parent().addClass(waitingClass);
}

/**
 * Allow form submission again
 */
Forms.releaseForms = function() {
	var forms = Forms.getForms();
	forms
		.removeClass(waitingClass)
		.find(formButtons)
		.css({'visibility': ''})
		.parent().removeClass(waitingClass)
		.find('.'+waitClass).remove();
}

/**
 * Scroll page to messages if there are any and the user is not already scrolled down
 */
Forms.scrollToMessages = function() {
	if ($(document).scrollTop() === 0) {
		var $msgs = $('.messages');
		if ($msgs.length) {
			$('html, body').stop(true);
			
			var top = $msgs.first().offset().top - 50;
			var left = $msgs.first().offset().left - 50;
			
			var sectionScroller = $(document.body).data('sectionScroller');
			if (sectionScroller !== undefined) {
				sectionScroller.animateTo(left, top);
			} else {
				$('body').animate({'scrollTop' : top}, 1000, 'easeOutQuart');
			}
		}
	}
}

/**
 * Initialize forms. Can be called multiple times to reset forms.
 */
Forms.init = function() {
	var forms = Forms.getForms();
	
	// Fixes ajax auto-populate issue (e.g. "purpose" field that shows more fields based on value)
	forms.find('[onchange]').each(function(){
		var $this = $(this);
		if ($this.val().length) { // TODO Expand this code to work well with more field types. Think about checkboxes and radios.
			$this.trigger('change');
		}
	});
	
	// Setup AJAX Forms
	if (!isAJAXSetup) {
		// Setup form listeners
		document.addEventListener('jsfAjaxEvent', function(event) {
			var fireType = event.detail.fireType;
			if (fireType === 'begin') {
				resetForms();
				Forms.pauseForms();
			} else if (fireType === 'always') {
				resetForms();
				Forms.releaseForms();
			}
		});
		$(document.body).on('jsfAjaxBegin', function() { resetForms();pauseForms(); });
		$(document.body).on('jsfAjaxAlways', function() { 
			Forms.releaseForms(); 
		});
		
		isAJAXSetup = true;
	}

	var styleAndScroll = function() {
		//Prevent double submit of forms
		var formSubmitEvents = 'jsfAjaxBegin submit';
		$body.on(formSubmitEvents, forms, formEventListener);
		
		// Add a class to fieldArea when user is hovering over or has focus on a form field. We use this to show any field specific messages.
		var formFieldEvents = 'mouseenter mouseleave focus blur';
		var formFieldSelector = 'input, select, textarea';
		$body.on(formFieldEvents, formFieldSelector, formFieldEventListener);
	
		// Add a class to fieldArea when not empty
		var formValueEvents = 'change keyup manualTrigger.change';
		var formValueSelector = 'input, select, textarea';
		$body.on(formValueEvents, formValueSelector, formValueListener);
		// Trigger event to cause fields to be setup. We use a custom event instead of 'change' because if we use 'change' the a4j:support
		//   on some fields causes ajax, which then causes the function we are in to be called again -- which means infinite loop.
		forms.find(formValueSelector).trigger('manualTrigger.change');
		
		// Scroll to Messages
		Forms.scrollToMessages();
	}
	
	$(document.body).on('jsfAjaxAlways', styleAndScroll);
	
	styleAndScroll();
} 

/**
 * @private
 * @param event
 */
function formEventListener(event){
	if ($(this).hasClass(waitingClass)) {
		event.preventDefault();
		return false;
	} else {
		Forms.pauseForms();
	}
}

/**
 * @private
 * @param event
 */
function formFieldEventListener(event) {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');
	if (!$area.length) { return };
	
	var eventType = event.type;
	
	if (eventType === 'mouseenter') {
		$area.addClass(hoverClass);
	} else if (
		(eventType === 'mouseleave' && !$area.hasClass(focusClass)) ||
		(eventType === 'blur') ||
		(eventType === 'focusout')
	) {
		$area.removeClass(hoverClass);
		$area.removeClass(focusClass);
	} else if (eventType.indexOf('focus') > -1) {
		if (($input.get(0).type === 'select-one') && $area.hasClass(hoverClass)) {
			// Remove if user clicked to open a select one field. Otherwise the arrow is partially visible.
			$area.removeClass(focusClass);
		} else {
			$area.addClass(focusClass);
		}
	}
}

/**
 * @private
 */
function formValueListener() {
	var $input = $(this);
	var $area = $input.closest('.fieldArea');
	if (!$area.length) {
		return;
	}
	
	var addClass = $input.val() !== '';
	
	$area.toggleClass(filledClass, addClass);
}



module.exports = Forms;

